const SubscriptionFrequencyOption = {
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    never: 'Never',
};

export default SubscriptionFrequencyOption;
